import DOMPurify from "dompurify";

const ALLOWED_TAGS = [
  "p", "br", "strong", "b", "em", "i", "u", "s",
  "ul", "ol", "li",
  "h1", "h2", "h3", "h4",
  "blockquote", "code", "pre",
  "a", "span",
];

const ALLOWED_ATTR = ["href", "title", "target", "rel"];

/**
 * Detect whether a string is HTML markup. If it isn't, the caller can render
 * it as plain text (preserves whitespace) — this keeps legacy plain-text
 * descriptions readable without forcing a DB migration.
 */
export function looksLikeHtml(s) {
  if (!s) return false;
  return /<\/?[a-z][\s\S]*?>/i.test(s);
}

/**
 * Sanitize HTML from the API for safe injection via dangerouslySetInnerHTML.
 * The backend is the canonical sanitizer; this is a defense-in-depth layer.
 */
export function safeHtml(html) {
  return DOMPurify.sanitize(html || "", {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    // Force-add target/rel on any link DOMPurify lets through
    ADD_ATTR: ["target", "rel"],
  });
}
